<app-content-header 
    [historyBack]="false" 
    (backEvent)="onBack()" 
    [headline]="'availability_header_text' | i18next">
</app-content-header>

<div class="flex-column h-100 d-flex">
    <div class="row mt-5 g-2 justify-content-center">
        <div class="col-12 col-md-5 mb-3 mb-md-0">
            <app-base-price-card 
                name="availability_standard" 
                [product]="standardLevel.name" 
                [price]="standardLevel.list_price" 
                [isSelected]="selectedAvailability === 'standard'"
                [buttonText]="'availability_button_standard' | i18next"
                (selected)="onStandardSelected()">
                <div class="h3 mx-auto text-danger fw-bold mb-3 mt-4 ">{{ 'availability_body_headline' | i18next }}</div>
                <div [innerHTML]="'availability_standard_body' | i18next"></div>
            </app-base-price-card>
        </div>
        <div class="col-12 col-md-5">
            <app-base-price-card 
                name="availability_premium" 
                [product]="premiumLevel.name" 
                [price]="premiumLevel.list_price" 
                [isSelected]="selectedAvailability === 'premium'"
                [buttonText]="'availability_button_premium' | i18next"
                (selected)="onPremiumSelected()">
                <div class="h3 mx-auto text-danger fw-bold mb-3 mt-4 ">{{ 'availability_body_headline' | i18next }}</div>
                <div [innerHTML]="'availability_premium_body' | i18next"></div>
            </app-base-price-card>
        </div>
    </div>
    <div class="ml-auto mt-auto p-3 small">{{ 'vat_not_included' | i18next }}</div>
</div>